import React from 'react'
import image from '../../../assets/logos/validando_cuenta.png'
import { useTranslation } from "react-i18next"
import { Grid, useMediaQuery } from '@material-ui/core'
import './verify-contract.css'


/**
 * @param {*} props
 * @return {*} 
 * @status no delete
 */
const VerifyContract = (props) => {
  const { t } = useTranslation()
  const longmatches = useMediaQuery('(max-width:768px)')

  const imageContainer = {
    display: 'block',
    margin: 'auto'
  }
  if (longmatches) {
    imageContainer.display = 'none'
  }

  return (
    <div>
      {longmatches ?
        <div className='text-active-plan'>
          <h4 className='text-pay'>{t('verify.titlePayVerify')}</h4>
          <span>{t('verify.textPayVerify')}</span>
        </div>
        :
        <div style={imageContainer}>
          <img className='verify-contract-image ' alt='' src={image} />
        </div>
      }

    </div>
  )
}
export { VerifyContract as default }